import { z } from "zod";
const RESERVED_OBJECT_ID_PREFIX = "x-sn-reserved-";
// Really only checks if the schema does not have the reserved prefix
export const SafeIdSchema = z.string().refine((value) => {
    return !value.startsWith(RESERVED_OBJECT_ID_PREFIX);
}, {
    message: `ID value can't start with ${RESERVED_OBJECT_ID_PREFIX}`,
});
